export const LOAD_USERS_LIST = 'LOAD_USERS_LIST';
export const LOAD_USERS_LIST_FULFILLED = `${LOAD_USERS_LIST}_FULFILLED`;

export const EDIT_USER = 'EDIT_USER';
export const EDIT_USER_PENDING = `${EDIT_USER}_PENDING`;
export const EDIT_USER_FULFILLED = `${EDIT_USER}_FULFILLED`;
export const EDIT_USER_REJECTED = `${EDIT_USER}_REJECTED`;
export const SET_EDIT_USER_PROPERTY = 'SET_EDIT_USER_PROPERTY';
export const CANCEL_EDIT_USER = 'CANCEL_EDIT_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_PENDING = `${UPDATE_USER}_PENDING`;
export const UPDATE_USER_FULFILLED = `${UPDATE_USER}_FULFILLED`;
export const UPDATE_USER_REJECTED = `${UPDATE_USER}_REJECTED`;

export const SHOW_SET_USER_PASSWORD = 'SHOW_SET_USER_PASSWORD';
export const SET_SET_USER_PASSWORD_MODEL_PROPERTY = 'SET_SET_USER_PASSWORD_MODEL_PROPERTY';
export const CANCEL_SET_USER_PASSWORD = 'CANCEL_SET_USER_PASSWORD';
export const SET_USER_PASSWORD = 'SET_USER_PASSWORD';
export const SET_USER_PASSWORD_PENDING = `${SET_USER_PASSWORD}_PENDING`;
export const SET_USER_PASSWORD_FULFILLED = `${SET_USER_PASSWORD}_FULFILLED`;
export const SET_USER_PASSWORD_REJECTED = `${SET_USER_PASSWORD}_REJECTED`;

export const CONFIRM_DISABLE_USER = 'CONFIRM_DISABLE_USER';
export const CANCEL_DISABLE_USER = 'CANCEL_DISABLE_USER';
export const DISABLE_USER = 'DISABLE_USER';
export const DISABLE_USER_PENDING = `${DISABLE_USER}_PENDING`;
export const DISABLE_USER_FULFILLED = `${DISABLE_USER}_FULFILLED`;
export const DISABLE_USER_REJECTED = `${DISABLE_USER}_REJECTED`;

export const CONFIRM_ENABLE_USER = 'CONFIRM_ENABLE_USER';
export const CANCEL_ENABLE_USER = 'CANCEL_ENABLE_USER';
export const ENABLE_USER = 'ENABLE_USER';
export const ENABLE_USER_PENDING = `${ENABLE_USER}_PENDING`;
export const ENABLE_USER_FULFILLED = `${ENABLE_USER}_FULFILLED`;
export const ENABLE_USER_REJECTED = `${ENABLE_USER}_REJECTED`;



// WEBPACK FOOTER //
// ./app/features/users/actions/types.js